import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import i18n from "./i18n";
import "@/sass/all.scss";

import "dayjs/locale/fr";

var dayjs = require("dayjs");

const eventBus = new Vue();
Vue.config.productionTip = process.env.NODE_ENV == "development";

Vue.mixin({
  computed: {
    appInstance: {
      get() {
        return Vue.options;
      },
    },
    $eventBus: {
      get() {
        return eventBus;
      },
    },
    $dayjs: {
      get() {
        dayjs.locale(this.$store.getters["getLanguage"]);
        return dayjs;
      },
    },
  },
});

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
